import { SwUpdate, VersionEvent, VersionReadyEvent } from '@angular/service-worker';
import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs';


@Injectable()
export class UpdateService {
  updates: SwUpdate;
  checkDone: EventEmitter<boolean> = new EventEmitter<boolean>();
  updateInProgress: EventEmitter<boolean> = new EventEmitter<boolean>();
  noServiceWorker: boolean = null; 

  constructor(updates: SwUpdate) {
    this.updates = updates;
    if (this.updates.isEnabled) {
      this.checkDone.emit(false);
      let updateSub: Subscription = this.updates.versionUpdates.subscribe((data: VersionEvent) => {
        if (data.type === "VERSION_READY") {
          if(data.latestVersion.hash != data.currentVersion.hash) {
            this.updateInProgress.emit(true);
            this.updates.activateUpdate().then(() => {
              window.location.reload();
            });
          }
          else this.checkDone.emit(true);
        }
      });

      this.updates.checkForUpdate().then(_ => {
        this.checkDone.emit(true);
        if (updateSub != null) updateSub.unsubscribe();
      });
    }
    else {
      this.noServiceWorker = true;
      console.log("Pas de service workers");
    }
  }
}
